import { z } from 'zod';
export const UTM_PARAM_NAMES = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
];
const URL_MAX_LENGTH = 2048;
const UTM_VALUE_MAX_LENGTH = 512;
const utmValueSchema = z.string().trim().min(1).max(UTM_VALUE_MAX_LENGTH);
export const acquisitionSourceSchema = z.object({
    url: z.string().trim().min(1).max(URL_MAX_LENGTH).optional(),
    utm: z
        .object({
        utm_source: utmValueSchema.optional(),
        utm_medium: utmValueSchema.optional(),
        utm_campaign: utmValueSchema.optional(),
        utm_content: utmValueSchema.optional(),
        utm_term: utmValueSchema.optional(),
        gclid: utmValueSchema.optional(),
    })
        .optional(),
});
export function parseAcquisitionSource(landingUrl) {
    const url = landingUrl.trim();
    if (!url) {
        return undefined;
    }
    let params;
    try {
        params = new URL(url).searchParams;
    }
    catch {
        params = new URLSearchParams();
    }
    const utm = {};
    for (const name of UTM_PARAM_NAMES) {
        const value = params.get(name)?.trim().slice(0, UTM_VALUE_MAX_LENGTH).trim();
        if (value) {
            utm[name] = value;
        }
    }
    const hasUtm = Object.keys(utm).length > 0;
    const keepsUrl = url.length <= URL_MAX_LENGTH;
    if (!hasUtm && !keepsUrl) {
        return undefined;
    }
    const candidate = { ...(keepsUrl ? { url } : {}), ...(hasUtm ? { utm } : {}) };
    const result = acquisitionSourceSchema.safeParse(candidate);
    return result.success ? result.data : undefined;
}
